"use strict";

exports.VerificationStepId = exports.TransactionStatus = exports.SdkError = exports.ErrorContextComponent = void 0;
/**
 * The type of a target network address, which can be "native" or a string of an address.
 */
let TransactionStatus = exports.TransactionStatus = /*#__PURE__*/function (TransactionStatus) {
  TransactionStatus[TransactionStatus["Pending"] = 0] = "Pending";
  TransactionStatus[TransactionStatus["Paid"] = 1] = "Paid";
  TransactionStatus[TransactionStatus["Verified"] = 2] = "Verified";
  return TransactionStatus;
}({});
/**
 * An interface for the payload of a transaction to be verified.
 */
/**
 * Version of the verification payload with the target token amount in any BigNumber format.
 * This needs to be converted into a Hex String before sending to the server.
 */
/**
 * Version of the verification payload with the target token amount in Hex String format.
 * To allow for safe integer transfer of BigNumbers between the client and the server.
 */
/**
 * An interface for the properties of the `PresendVerificationSDK` class.
 */
/**
 * An interface for the properties of the `verifyTransactionAsync` method.
 */
/**
 * An interface for the properties of the `verifyTransactionAsync` method.
 */
/**
 * An interface for the properties of the `calculatePresendFeeAsync` method.
 * This method is used to calculate the fee for a transaction.
 */
/**
 * Represents the response object for the presend fee.
 */
/**
 * An interface for the properties of the `getSignedSourceAddressValidationPayloadAsync` method.
 */
/**
 * An interface for the properties of the `getSupportedNetworksAsync` method.
 */
/**
 * An interface or the properties of the `getTransactionHistoryBySourceAsync` , `getTransactionHistory` and `getTransactionHistoryByAffiliateAsync`
 */
let ErrorContextComponent = exports.ErrorContextComponent = /*#__PURE__*/function (ErrorContextComponent) {
  ErrorContextComponent[ErrorContextComponent["VERIFICATION_PAYMENT_LAMBDA"] = 0] = "VERIFICATION_PAYMENT_LAMBDA";
  ErrorContextComponent[ErrorContextComponent["VERIFICATION_VERIFICATION_LAMBDA"] = 1] = "VERIFICATION_VERIFICATION_LAMBDA";
  ErrorContextComponent[ErrorContextComponent["VERIFICATION_SUPPORTED_ASSETS_LAMBDA"] = 2] = "VERIFICATION_SUPPORTED_ASSETS_LAMBDA";
  ErrorContextComponent[ErrorContextComponent["SDK_PRESEND_VERIFICATION"] = 3] = "SDK_PRESEND_VERIFICATION";
  ErrorContextComponent[ErrorContextComponent["SDK_GET_APPROVED_PAYMENT_TOKEN"] = 4] = "SDK_GET_APPROVED_PAYMENT_TOKEN";
  ErrorContextComponent[ErrorContextComponent["SDK_VERIFY_TRANSACTION"] = 5] = "SDK_VERIFY_TRANSACTION";
  ErrorContextComponent[ErrorContextComponent["SDK_GET_BYPASS_ELIGIBILITY"] = 6] = "SDK_GET_BYPASS_ELIGIBILITY";
  ErrorContextComponent[ErrorContextComponent["SDK_TRANSACTION_UTILITY"] = 7] = "SDK_TRANSACTION_UTILITY";
  ErrorContextComponent[ErrorContextComponent["SDK_PRICING_UTILITY"] = 8] = "SDK_PRICING_UTILITY";
  ErrorContextComponent[ErrorContextComponent["DEXSCREENER_FIND_USD_TOKEN_PAIR"] = 9] = "DEXSCREENER_FIND_USD_TOKEN_PAIR";
  ErrorContextComponent[ErrorContextComponent["DEXSCREENER_GET_PRICE_FOR_TOKEN_ADDRESS"] = 10] = "DEXSCREENER_GET_PRICE_FOR_TOKEN_ADDRESS";
  ErrorContextComponent[ErrorContextComponent["DEXSCREENER_GET_PRICE_FOR_PAIR"] = 11] = "DEXSCREENER_GET_PRICE_FOR_PAIR";
  ErrorContextComponent[ErrorContextComponent["REFERRAL_GET_REFERRAL_ADDRESS_FOR_SOURCE_ADDRESS"] = 12] = "REFERRAL_GET_REFERRAL_ADDRESS_FOR_SOURCE_ADDRESS";
  ErrorContextComponent[ErrorContextComponent["SDK_RESUME_TRANSACTION"] = 13] = "SDK_RESUME_TRANSACTION";
  return ErrorContextComponent;
}({});
class SdkError extends Error {
  constructor(msg, name, context) {
    super(msg);
    this.name = name;
    this.context = context;
  }
}
exports.SdkError = SdkError;
let VerificationStepId = exports.VerificationStepId = /*#__PURE__*/function (VerificationStepId) {
  VerificationStepId[VerificationStepId["SANITY"] = 0] = "SANITY";
  VerificationStepId[VerificationStepId["SUPPORTED_EXCHANGE"] = 1] = "SUPPORTED_EXCHANGE";
  VerificationStepId[VerificationStepId["SUPPORTED_TOKEN_ON_EXCHANGE"] = 2] = "SUPPORTED_TOKEN_ON_EXCHANGE";
  VerificationStepId[VerificationStepId["SUPPORTED_TOKEN_ON_EXCHANGE_ON_NETWORK"] = 3] = "SUPPORTED_TOKEN_ON_EXCHANGE_ON_NETWORK";
  VerificationStepId[VerificationStepId["SUPPORTED_TOKEN_AT_ADDRESS_ON_NETWORK"] = 4] = "SUPPORTED_TOKEN_AT_ADDRESS_ON_NETWORK";
  return VerificationStepId;
}({});